import { jsx as _jsx } from "react/jsx-runtime";
import config from '@iotv/config';
import { readableDeviceName } from '@iotv/core-services';
import { edgeTypeMatrix, pluralize } from '@iotv/datamodel';
import { camelCase_to_Sentence, toTitleCase } from '@iotv/datamodel-core';
import { DeviceTypes, UNCLASSIFIED_DOMAIN } from '@iotv/iotv-v3-types';
import { TreeItem2 as TreeItem } from '@mui/x-tree-view';
import { useContext } from 'react';
import { AlertErrors } from '../../../../ErrorHandling/ErrorBoundaryFallback';
import { AdjacentType, ComparisonType, LogicalOperatorType } from '../../../../types/AppTypes';
import { ObjectTree } from '../../../../v2/components/generic/ObjectTree/ObjectTreev2';
import { NavigationSkeleton } from '../../../common/NavigationSkeleton';
import { getSingleTypeRecursivePath } from '../../../EnititySupport/RecusiveEntityGroup/getRecursiveQueryPath';
import { handleContextMenu } from '../../clickWrappers/helpers';
import { NavigationContext } from '../../NavigationContext';
const debug = process.env.REACT_APP_DEBUG && false;
/** Finds groups directly under a context object and iteratively queries down for subgroups and devices in those groups */
export const DeviceGroupTree = ({ deviceType, nodeEdgeMapper, contextObject, transactionFunctions, name, uniqueTreeId, domain }) => {
    let key = `${uniqueTreeId}_Device_${deviceType}`;
    if (domain)
        key += `_${domain}`;
    const deviceTypeName = DeviceTypes[deviceType];
    const readableName = readableDeviceName(deviceType);
    const navigationContext = useContext(NavigationContext);
    const nodeFilters = [
        { setOperation: LogicalOperatorType.AND, filters: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: 'Device' }] },
    ];
    if (domain !== undefined && domain !== UNCLASSIFIED_DOMAIN)
        nodeFilters.push({
            setOperation: LogicalOperatorType.AND,
            filters: [
                { key: 'domain', predicate: ComparisonType.EQUALS, value: domain },
                { key: 'subSupportedType', predicate: ComparisonType.EQUALS, value: deviceType },
            ],
        });
    return (_jsx(TreeItem, { itemId: key, label: contextObject.type === 'Customer'
            ? handleContextMenu(name ??
                `${config.app?.webUI?.groupedObjectTypes?.['Device']?.pluralCollectionName ?? readableName ?? pluralize(toTitleCase(camelCase_to_Sentence(deviceTypeName)))}`, 'Device', navigationContext, deviceType, domain !== UNCLASSIFIED_DOMAIN ? domain : undefined)
            : (name ??
                `${config.app?.webUI?.groupedObjectTypes?.['Device']?.pluralCollectionName ?? readableName ?? pluralize(toTitleCase(camelCase_to_Sentence(deviceTypeName)))}`), children: _jsx(ObjectTree, { uniqueTreeId: key,
            nodeEdgeMapper,
            contextObjects: [contextObject],
            queryPaths: [
                {
                    stepQuery: {
                        objectTypeId: 'Group',
                        adjacencyType: AdjacentType.CHILD,
                        edgeTypeId: edgeTypeMatrix.Customer.Group.customer_has_group.edgeTypeId,
                        nodeFilters,
                    },
                    nextSteps: getSingleTypeRecursivePath({
                        groupObjectType: 'Group',
                        containedObjectType: 'Device',
                    }),
                },
            ],
            transactionFunctions,
            hideTopStep: true,
            maintree_rightclick: true }, key) }, key));
};
export const SpecificDeviceGroupTree = (deviceType, domain, uniqueTreeId) => ({ applicationData, contextCustomer, transactionFunctions }) => (_jsx(AlertErrors, { children: contextCustomer ? (_jsx(DeviceGroupTree, { contextObject: contextCustomer, deviceType, nodeEdgeMapper: applicationData, transactionFunctions, uniqueTreeId, domain }, `${deviceType}_${domain}_${uniqueTreeId}`)) : (_jsx(NavigationSkeleton, {}, `${deviceType}_${domain}_${uniqueTreeId}`)) }, `${deviceType}_${domain}_${uniqueTreeId}` + '_errors'));
